import React from 'react';
import { Textarea as CTextarea } from '@chakra-ui/react';

const Textarea = ({ ...props }) => {
  return <CTextarea variant={'unstyled'} type="text" {...props} />;
};

export default Textarea;
